import { Camera, type LucideIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import defaultLogo from "../assets/harmony_logo.png";

export type OnboardingTabKey = "selfie";

export interface OnboardingHeaderTab {
  key: OnboardingTabKey;
  label?: string;
}

const DEFAULT_TABS: OnboardingHeaderTab[] = [
  { key: "selfie" },
];

const ICON_BY_TAB: Record<OnboardingTabKey, LucideIcon> = {
  selfie: Camera,
};

interface OnboardingHeaderProps {
  activeTab: OnboardingTabKey;
  onTabChange?: (tab: OnboardingTabKey) => void;
  tabs?: OnboardingHeaderTab[];
  brandName?: string;
  logoSrc?: string;
  rightSlot?: React.ReactNode;
}

export function OnboardingHeader({
  activeTab,
  onTabChange,
  tabs = DEFAULT_TABS,
  brandName,
  logoSrc = defaultLogo,
  rightSlot,
}: OnboardingHeaderProps) {
  const { t } = useTranslation();

  return (
    <header className="border-b border-border-primary bg-bg-primary/80 backdrop-blur-sm">
      <div className="max-w-5xl mx-auto px-6 lg:px-12 py-4 flex items-center justify-between">
        
        <div className="flex items-center gap-8">
          <div className="flex items-center gap-2.5">
            <img src={logoSrc} alt={brandName ?? "Logo"} className="h-8 w-auto" />
            {/* 🚀 DÜZELTME: Mavi renk silindi, text-text-primary yapıldı */}
            <h1 className="text-xl sm:text-2xl font-extrabold tracking-tighter text-text-primary">
              {brandName ?? t("onboarding.appName")}
            </h1>
          </div>
          
          <nav className="hidden md:flex items-center gap-6">
            {tabs.map((tab) => {
              const Icon = ICON_BY_TAB[tab.key];
              const isActive = activeTab === tab.key;
              const label = tab.label ?? t(`onboarding.tabs.${tab.key}`);
              return (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => !isActive && onTabChange?.(tab.key)}
                  // 🚀 DÜZELTME: Aktif sekme rengi mavi yerine standart text-text-primary oldu
                  className={cn(
                    "flex items-center gap-1.5 px-1 py-1.5 text-sm font-bold border-b-2 transition-colors",
                    isActive
                      ? "text-text-primary border-text-primary"
                      : "text-text-secondary hover:text-text-primary border-transparent"
                  )}
                >
                  <Icon className="h-4 w-4" /> {label}
                </button>
              );
            })}
          </nav>
        </div>
        
        <div className="flex items-center gap-4">
          {rightSlot}
        </div>

      </div>
    </header>
  );
}